// ユーザー情報
const User = {
  namespaced: true,

  state: {
    user: {},
    permissions: {},
  },
  getters: {
    getUser: state => {
      return state.user
    },
    getPermissions: state => {
      return state.permissions
    },
    getUserHasChiefPassword: state => {
      return state.user.has_chief_password
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setPermissions(state, permissions) {
      state.permissions = permissions
    },
    setUserHasChiefPassword(state, has_chief_password) {
      state.user.has_chief_password = has_chief_password
    },
  },
  actions: {},
}

export default User
